import React from "react";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import SyaratKetentuanDocument from "./components/SyaratKetentuanDocument";
import SyaratKetentuanPageFooter from "./components/SyaratKetentuanPageFooter";
import SyaratKetentuanPageHeader from "./components/SyaratKetentuanPageHeader";
import SyaratKetentuanPageLayout from "./components/SyaratKetentuanPageLayout";

const SyaratKetentuanPage = () => {
    return (
        <ThemeDefaultComponent>
            <SyaratKetentuanPageLayout>
                <SyaratKetentuanPageHeader />
                <SyaratKetentuanDocument />
                <SyaratKetentuanPageFooter />
            </SyaratKetentuanPageLayout>
        </ThemeDefaultComponent>
    );
};

export default SyaratKetentuanPage;
